import React from 'react';
import AppBar from './AppBar';

const AppBarProvider = () => {
  return <AppBar />;
};

export default AppBarProvider;
